import { useEffect, useState } from "react";
import { adminApi, errMsg } from "../api";
import { Toggle } from "../components";
import { toast } from "../../components/ui/sonner";

export default function StatsAdmin() {
  const [stats, setStats] = useState([]);
  const load = () => adminApi.get("/admin/stats").then((r) => setStats(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const save = async (s, patch) => {
    try {
      await adminApi.put(`/admin/stats/${s.id}`, { ...s, ...patch });
      toast.success("Stat updated");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  const update = (id, patch) => setStats(stats.map((s) => (s.id === id ? { ...s, ...patch } : s)));

  return (
    <div data-testid="admin-stats-page">
      <div className="adm-head">
        <div><h1>Stats strip</h1><div className="sub">Toggle visibility per stat — hidden stats never render publicly</div></div>
      </div>
      {stats.map((s) => (
        <div className="adm-card" key={s.id} data-testid={`stat-row-${s.order}`}>
          <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
            <input style={{ maxWidth: 110, fontWeight: 700 }} value={s.value} onChange={(e) => update(s.id, { value: e.target.value })} data-testid={`stat-value-${s.order}`} />
            <input style={{ flex: 1, minWidth: 220 }} value={s.label} onChange={(e) => update(s.id, { label: e.target.value })} data-testid={`stat-label-${s.order}`} />
            <input style={{ maxWidth: 80 }} type="number" value={s.order} onChange={(e) => update(s.id, { order: Number(e.target.value) })} title="Order" />
            <Toggle checked={s.visible} onChange={(v) => update(s.id, { visible: v })} label={s.visible ? "Visible" : "Hidden"} testid={`stat-visible-${s.order}`} />
            <button className="adm-btn primary sm" onClick={() => save(s)} data-testid={`stat-save-${s.order}`}>Save</button>
          </div>
        </div>
      ))}
    </div>
  );
}
